import React from 'react'
import { Card } from '@braze/web-sdk'
import { useBraze, useConfig } from 'msp-integrations'
import { ContentCardTermsAndConditionsProps } from './ContentCardTermsAndConditions.types'
import { twMerge } from 'tailwind-merge'

const ContentCardTermsAndConditions = ({
  className,
  pageId
}: ContentCardTermsAndConditionsProps) => {
  const { termsConditionsCards } = useBraze()
  const {
    theme: { font }
  } = useConfig()

  const filteredCards = (Array.from(termsConditionsCards.values()) as Card[])
    .filter((card: any) => {
      return card.extras?.page === pageId
    })
    .sort((a: Card, b: Card) => {
      return Number(a.extras?.position || 0) - Number(b.extras?.position || 0)
    })

  if (!filteredCards || filteredCards.length === 0) {
    return null
  }

  return (
    <div
      className={twMerge(font.regular, 'block px-16 py-4 lg:px-24', className)}
    >
      {filteredCards?.map((card: Card) => (
        <div key={card.extras?.terms_id || card.id}>
          <p className='font-medium'>{card?.title}</p>
          <p
            className='my-4'
            dangerouslySetInnerHTML={{ __html: card?.description || '' }}
          />
        </div>
      ))}
    </div>
  )
}

export default ContentCardTermsAndConditions
